import React from "react";
import { BsFillFolderFill } from "react-icons/bs";

const BADGE_COLORS = {
  PDF: "bg-red-500 text-white",
  Excel: "bg-green-500 text-white",
  XLS: "bg-green-500 text-white",
  PowerPoint: "bg-orange-500 text-white",
  PPT: "bg-orange-500 text-white",
  Word: "bg-blue-500 text-white",
  DOC: "bg-blue-500 text-white",
  ZIP: "bg-purple-500 text-white",
  Image: "bg-pink-500 text-white",
  Video: "bg-pink-500 text-white",
};

const TYPE_LABEL = {
  Excel: "XLS",
  PowerPoint: "PPT",
  Word: "DOC",
};

export const FileIcon = ({ type, size = 16 }) => {
  if (type === "Folder") {
    return <BsFillFolderFill size={size} className="text-blue-500 shrink-0" />;
  }

  const badge = BADGE_COLORS[type] || "bg-slate-500 text-white";
  let label = TYPE_LABEL[type] || type;
  if (!label || label === "File") label = "TXT";

  return (
    <div
      className={`shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-[10px] font-bold tracking-wider ${badge}`}
    >
      {label.substring(0, 3).toUpperCase()}
    </div>
  );
};

const STATUS_STYLES = {
  Published: "bg-emerald-50 text-emerald-600",
  Draft: "bg-slate-100 text-slate-500",
};

export const StatusBadge = ({ status }) => {
  const displayStatus = status || "Published";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide ${STATUS_STYLES[displayStatus] || "bg-slate-100 text-slate-600"
        }`}
    >
      {displayStatus}
    </span>
  );
};
